import {eq} from '@shared/helpers/lang'

import {
    PayMoneyUserStatus,
    PayMoneyUserStatusList,
    ChargeLimitSceneType,
    ChargeLimitScene,
    PAYMONEY_RESULT_TYPE,
    PayMoneyUserStatusValueType,
    PayMoneyUserAvailablePayStates,
} from '@web/core/constants'

/** 페이머니 상태 반환 */
export function getPayMoneyInfo(payMoneyUserStatus?: Maybe<PayMoneyUserStatusType>) {
    const status = payMoneyUserStatus ?? PayMoneyUserStatus.NOT_OPEN
    const eqPayMoneyUserStatus = eq(status)
    return {
        // 1.0 : 페이머니, 하나통장 미개설
        isUnOpened: eqPayMoneyUserStatus(PayMoneyUserStatus.NOT_OPEN),
        // 2.0 : 페이머니 > 페이머니 통장 잔액 이체 실패
        isFailed: eqPayMoneyUserStatus(PayMoneyUserStatus.TRANSFER_FAIL),
        // 3.0 : 페이머니 하나통장 연결 해지
        isDisconnected: eqPayMoneyUserStatus(PayMoneyUserStatus.DISCONNECTED),
        // 3.1: 미래에셋 페이머니 신설 이후 네통 개설 고객
        isReadyOpen: eqPayMoneyUserStatus(PayMoneyUserStatus.READY_OPEN),
        // 3.2: 미래에셋 페이머니 신설 이전 네통 개설 고객
        isNotReadyOpen: eqPayMoneyUserStatus(PayMoneyUserStatus.NOT_READY_OPEN),
        // 4.0: 페이머니 - 하나통장 개설 (정상)
        isConnected: eqPayMoneyUserStatus(PayMoneyUserStatus.OPEN),
        // 4.1: 거래중지
        isStopped: eqPayMoneyUserStatus(PayMoneyUserStatus.STOP_TRADING),
        // 4.2: 하나통장 간편결제 계좌 삭제
        isDeleted: eqPayMoneyUserStatus(PayMoneyUserStatus.EASY_BANK_DELETED),
        // 4.0, 4,1, 4.2 (페이머니 가입자)
        isPayMoneyUser: PayMoneyUserStatusList.includes(status),
        // 1.0, 3.0, 3.1, 3.2, 4.0 (결제가능)
        availablePayment: PayMoneyUserAvailablePayStates.includes(status),
    }
}

export function getPayMoneyAPIInfo(
    payMoneyUserResultType: Constant<typeof PAYMONEY_RESULT_TYPE>,
    chargeLimitResultType: Constant<typeof PAYMONEY_RESULT_TYPE>,
) {
    const payMoneyResultTypeEqualsTo = eq(payMoneyUserResultType)
    const chargeLimitResultTypeEqualsTo = eq(chargeLimitResultType)

    return {
        isPayMoneyRequestSucceed: payMoneyResultTypeEqualsTo(PAYMONEY_RESULT_TYPE.SUCCESS),
        isChargeLimitRequestSucceed: chargeLimitResultTypeEqualsTo(PAYMONEY_RESULT_TYPE.SUCCESS),
        isChargeLimitRequestRetryAvailable: chargeLimitResultTypeEqualsTo(PAYMONEY_RESULT_TYPE.FAILED_RETRY_AVAILABLE),
        isChargeLimitRequestFailed: chargeLimitResultTypeEqualsTo(PAYMONEY_RESULT_TYPE.FAILED),
    }
}

/**
 * 충전한도 API sceneType을 반환해주는 함수
 * DEFAULT : 주문형 주문서 정책
 * UNDER_MAINTENANCE : 디컨 정기결제 정책
 */
export function getPayMoneySceneInfo(chargeLimitScene: ChargeLimitSceneType) {
    const chargeLimitSceneEqaulsTo = eq(chargeLimitScene)

    return {
        isDefault: chargeLimitSceneEqaulsTo(ChargeLimitScene.DEFAULT),
        isUnderMaintenance: chargeLimitSceneEqaulsTo(ChargeLimitScene.UNDER_MAINTENANCE),
    }
}

const PayMoneyUserStatusVersionMap: Record<PayMoneyUserStatusValueType, PayMoneyUserStatusType> = {
    // 1.0 : 페이머니, 하나통장 미개설
    '1.0': PayMoneyUserStatus.NOT_OPEN,
    // 2.0 : 페이머니 > 페이머니 통장 잔액 이체 실패
    '2.0': PayMoneyUserStatus.TRANSFER_FAIL,
    // 3.0 : 페이머니 하나통장 연결 해지
    '3.0': PayMoneyUserStatus.DISCONNECTED,
    // 3.1: 미래에셋 페이머니 신설 이후 네통 개설 고객
    '3.1': PayMoneyUserStatus.READY_OPEN,
    // 3.2: 미래에셋 페이머니 신설 이전 네통 개설 고객
    '3.2': PayMoneyUserStatus.NOT_READY_OPEN,
    // 4.0: 페이머니 - 하나통장 개설 (정상)
    '4.0': PayMoneyUserStatus.OPEN,
    // 4.1: 거래중지
    '4.1': PayMoneyUserStatus.STOP_TRADING,
    // 4.2: 하나통장 간편결제 계좌 삭제
    '4.2': PayMoneyUserStatus.EASY_BANK_DELETED,
} as const

export function convertPaymoneyUserStatusType(userStatus: PayMoneyUserStatusValueType): PayMoneyUserStatusType {
    return PayMoneyUserStatusVersionMap[userStatus]
}
